import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-my-dialog',
    standalone: true,
    templateUrl: './my-dialog.component.html',
    styleUrls: ['./my-dialog.component.css'],
    imports: [CommonModule, MatDialogModule, MatButtonModule]
})
export class MyDialogComponent {

  constructor(public dialogRef: MatDialogRef<MyDialogComponent>
    ,@Inject(MAT_DIALOG_DATA) public data: any) {

     }


  cancel(){
  }

  ok(){
    this.dialogRef.close("can pass string");
  }

}
